module.exports = __webpack_public_path__ + "assets/kick.e164cf05.svg";